<div
  *ngIf="!isDisabled && cartContents && cartContents.rows"
  ngbDropdown
  display="dynamic"
  placement="bottom-right"
  #myDrop="ngbDropdown"
  routerLink="/checkout"
  (mouseenter)="$event.stopPropagation(); myDrop.open()"
  (mouseleave)="$event.stopPropagation(); myDrop.close()"
>
  <div class="d-block">
    <button class="btn cart-button" role="button" id="cartIcon" ngbDropdownAnchor>
      <i [ngClass]="cartContents ? 'fas fa-shopping-cart' : 'fa fa-spinner fa-pulse fa-fw'"></i>
      <span *ngIf="!!cartContents" class="badge badge-pill nav-bar-icon-badge text-white">{{ productsCount }}</span>
    </button>
    <div ngbDropdownMenu aria-labelledby="cartIcon" class="pb-0">
      <div class="cart-content" *ngIf="!!cartContents">
        <div class="container d-block">
          <div class="row">
            <div class="col">
              <h1></h1>
            </div>
          </div>
          <div class="row">
            <div class="col-auto">
              <h2 translate>CART</h2>
              <button
                type="button"
                class="btn btn-sm pl-0 mb-3 text-colmec-red"
                (click)="$event.preventDefault(); $event.stopPropagation(); clearCart()"
                translate
              >
                CLEAR_CART
              </button>
            </div>
          </div>
          <div class="row cart-rows mr-1">
            <div class="col-12">
              <div class="cart-row p-1 py-3 my-1 mb-2" *ngFor="let row of cartContents.rows">
                <div class="row">
                  <div class="col-3 d-flex align-items-center">
                    <img
                      *ngIf="row.product.extra.images && row.product.extra.images[0] as image; else noimage"
                      class="card-img-top img-fluid mx-auto d-block"
                      src="https://cdn1.gung.io/fit-in/350x350/filters:fill(white):background_color(white):etag({{
                        image.s3ETag
                      }}):format(jpeg)/{{ image.s3Uri }}"
                      alt="{{ image.description }}"
                    />
                    <ng-template #noimage>
                      <img
                        class="card-img-top img-fluid w-100"
                        src="https://cdn1.gung.io/fit-in/300x300/images/no-image.jpg"
                        alt="NO IMAGE"
                        class="img-fluid mx-auto d-block"
                      />
                    </ng-template>
                  </div>
                  <div class="col-5 d-flex align-items-center flex-column pl-0">
                    <span>
                      <a routerLink="/product/{{ row.cartRow.productId }}" class="text-primary font-weight-bold">
                        <b>{{ row.product.id }}</b> - {{ row.product.name }}
                      </a>
                      <div class="small">{{ row.product.extra.ar?.artbeskrspec }}</div>
                      <span
                        class="d-block small"
                        *ngIf="
                          !!row.product.extra.ar.q_bransleeff &&
                          !!row.product.extra.ar.q_vatgrepp &&
                          !!row.product.extra.ar.q_bullervarde &&
                          !!row.product.extra.ar.q_bullerklass
                        "
                      >
                        <span class="" translate>EU_LABELING</span>:
                        <span
                          >{{
                            getOptionName('q_bransleeff', 'q_bransleeffdesc', row.product.extra.ar.q_bransleeff)
                          }}/</span
                        >
                        <span
                          >{{ getOptionName('q_vatgrepp', 'q_vatgreppdesc', row.product.extra.ar.q_vatgrepp) }}/</span
                        >
                        <span
                          >{{
                            getOptionName('q_bullervarde', 'q_bullervardedesc', row.product.extra.ar.q_bullervarde)
                          }}/</span
                        >
                        <span>{{
                          getOptionName('q_bullerklass', 'q_bullerklassdesc', row.product.extra.ar.q_bullerklass)
                        }}</span>
                      </span>
                      <span [ngClass]="{ 'd-block': !hidePrice, 'd-none': hidePrice }">{{
                        row.price.cartRowTotalPriceInclRowDiscount.value
                          | gungCurrency: row.price.cartRowTotalPriceInclRowDiscount.currencyCode
                      }}</span>
                    </span>
                    <!-- <div *ngIf="row.price.customerGrossPrice.value != row.price.cartRowUnitPriceInclRowDiscount.value" [class.d-none]="hidePrice">

                      <div style="padding-top: 2px">{{ 'PRICE' | translate }}:
                        {{row.price.cartRowUnitPrice.value | currency: row.price.cartRowUnitPrice.currencyCode }}
                      </div>

                      <div style="padding-top: 2px">{{ 'DISCOUNT' | translate }}:
                        <span *ngIf="row.price.cartRowDiscountPercent !== 0">
                          -{{row.price.cartRowDiscountPercent}}%
                        </span>
                      </div>

                      <div style="padding-top: 2px">{{ 'NET_PRICE' | translate }}:
                        {{row.price.cartRowUnitPriceInclRowDiscount.value | currency: row.price.customerNetPrice.currencyCode }}
                      </div>
                    </div> -->
                  </div>
                  <div class="col-3 d-flex align-items-center">
                    <button type="button" class="btn btn-link" (click)="updateQty(row.cartRow, row.cartRow.qty - 1)">
                      -
                    </button>
                    {{ row.cartRow.qty }}
                    <button type="button" class="btn btn-link" (click)="updateQty(row.cartRow, row.cartRow.qty + 1)">
                      +
                    </button>
                  </div>
                  <div class="col-1 position-relative">
                    <button
                      type="button"
                      class="btn btn-link delete-product text-secondary"
                      (click)="removeRow(row.cartRow)"
                    >
                      <i class="fas fa-times-circle fa-xs"></i>
                    </button>
                  </div>
                </div>
              </div>
              <!-- <div style="padding-bottom: 10%" *ngIf="productsAutoAdded"><span translate>CART_CONTAINS_AUTO_ADDED_PRODUCTS</span></div> -->
            </div>
          </div>
          <hr style="width: 96%; margin-left: 2%" />
          <div class="row">
            <div class="col-12" [class.d-none]="hidePrice">
              <h5 class="d-flex justify-content-between">
                <span class="text-primary" tranlsate>TOTAL</span>
                <span class="font-weight-bold">{{
                  cartContents.totalValue | gungCurrency: cartContents.currency
                }}</span>
              </h5>
            </div>
          </div>
        </div>
        <button
          type="button"
          class="btn w-100 bg-primary text-white text-uppercase"
          routerLink="/checkout"
          (click)="$event.preventDefault(); $event.stopPropagation(); myDrop.close()"
          translate
        >
          CHECKOUT
        </button>
      </div>
    </div>
  </div>
</div>
